module.exports = __webpack_public_path__ + "static/media/multifunction.cbdd77af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/multifunction.jpg
// module id = 827
// module chunks = 3